"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnloadedFonts = void 0;
var _constants = require("./constants");
const fontExists = fontString => {
  let exists = false;
  window.document.fonts.forEach(font => {
    if (!exists) {
      const fontCheck = [font.display, font.family, font.style, font.weight].filter(Boolean).join(' ');
      exists = fontString === fontCheck;
    }
  });
  return exists;
};
const getUnloadedFonts = async function () {
  let emberUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.STENCIL_FONT_CDN_URL;
  const finalFontsString = [];
  await window.document.fonts.ready; // Wait for fonts to be loaded

  _constants.stencilFontProperties.forEach(fontProperty => {
    const fontCheck = [fontProperty.fontDisplay, fontProperty.fontFamily, fontProperty.fontStyle, fontProperty.fontWeight].filter(Boolean).join(' ');
    if (!fontExists(fontCheck)) {
      const fontRulesArray = [];
      fontRulesArray.push("font-family: '".concat(fontProperty.fontFamily, "';"));
      if (fontProperty.fontStyle) fontRulesArray.push("font-style: ".concat(fontProperty.fontStyle, ";"));
      if (fontProperty.fontWeight) fontRulesArray.push("font-weight: ".concat(fontProperty.fontWeight, ";"));
      fontRulesArray.push("src: url('".concat(emberUrl, "/").concat(fontProperty.filename, "') format('woff2');"));
      if (fontProperty.fontDisplay) fontRulesArray.push("font-display: ".concat(fontProperty.fontDisplay, ";"));
      const fontRules = fontRulesArray.join('\n');
      const appendedFontRule = "\n@font-face {\n".concat(fontRules, "\n}\n");
      finalFontsString.push(appendedFontRule);
    }
  });
  return finalFontsString.join('');
};
exports.getUnloadedFonts = getUnloadedFonts;